export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL_API = process.env.REACT_APP_BASE_API_URL;